import { Component, OnInit, Inject, Output, EventEmitter, HostListener } from '@angular/core';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { UnitsService } from 'src/app/services/UnitsService';
import { ClassificationModel } from 'src/app/models/ClassificationModel';
import { ClassificationService } from 'src/app/services/ClassificationService';
import { PharmGroupModel } from 'src/app/models/PharmGroupModel';
import { PharmGroupService } from 'src/app/services/PharmGroupService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { DataBankService } from 'src/app/services/DataBankService';
import { LocalStorage,LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ItemssearchComponent } from '../itemssearch/itemssearch.component';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { PatientModel } from 'src/app/models/PatientsModel';

import { CanserModel } from 'src/app/models/CanserModel';

import { CanserService } from 'src/app/services/CanserService';
import { PathologyModel } from 'src/app/models/PathologyModel';

import { PathologyService } from 'src/app/services/PathologyService';
import { GovernmentsModel, MasterdataModel } from 'src/app/models/Masterdata.Model';
import { masterdataService } from 'src/app/services/MasterdataService';

import { MortalityModel } from 'src/app/models/MortalityModel';
import { MortalityService } from 'src/app/services/MortalityService';
import { MortalityComponent } from '../mortality/mortality.component';
import swal from 'sweetalert2';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';
import { DomSanitizer } from '@angular/platform-browser';
import { PatientIsuranceComponent } from '../patient-isurance/patient-isurance.component';
import { PatientInsuranceService } from 'src/app/services/PatientInsuranceService';
import { PatientInsuranceModel } from 'src/app/models/PatientInsuranceModel';
import { IsuranceCopmanyService } from 'src/app/services/IsuranceCopmanyService';
import { InsuranceCompanyModel } from 'src/app/models/InsuranceCompanyModel';


@Component({
  selector: 'app-databank',
  templateUrl: './databank.component.html',
  styleUrls: ['./databank.component.css'],
})
export class DatabankComponent implements OnInit {
patientCode = '';
patientName = '';
patientFName = '';
patientLName = '';
birthDate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
diagnosis = '';
marital = '';
gov = 'القاهرة';
nationality ='Egyptian';
occupation = '';
email = '';
telMobile = '';
telHome = '';
addressHome = '';
cancerID = '';
docCode = '';
education = '';
status = '';
ageYear ='0';
gender = '';
telBusin='';
pathology = '';
compCode = '1';
userID='john';
ageYear1 =0;
birthDate_V :any;
Today = formatDate(new Date(), 'yyyy', 'en');
day1 :any;
recid = '0';
pattime = formatDate(new Date(), 'HH:mm', 'en');
medcompany = 0;
  ////----------Mortality -----------------
      mortalitypatientcode = '' ;
      mortalitydeath = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      mortalidate = '' ;
      mortalityreason = '' ;
      mortalitynotes = '' ;

      wk_Hied_Mortal = false;
  ///----------------------------------------
  dateEntry = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  yearEntry = formatDate(new Date(), 'yyyy', 'en');
  currenttime = formatDate(new Date(), 'HH:mm', 'en');
  ////-------------------------------------
  myimage :any;
  myimage2 = 'data:image/jpg;base64,'
  imageSrc;
  imageSource: any;
  sellersPermitFile: any;
  sellersPermitString = '';
  wk_Acc_Not = false;
  wk_Acc_Not1 = true;
  ///---------------------------------------
  doctorsList: DoctorsModel[] = [];
  cancerlist:CanserModel[] = [];
  PathologyList:PathologyModel[]=[];

  MasterListNa:MasterdataModel[]=[];
  MasterListGov:GovernmentsModel[]=[];
  MasterListNat:MasterdataModel[]=[];

  MasterList1:MasterdataModel[]=[];
  MasterList2:MasterdataModel[]=[];
  MasterList3:MasterdataModel[]=[];
  companyList: CompanyModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(
    public dataBankService: DataBankService,
    public dataBankModel: DatabankModel,
    public patientModel: PatientModel,
    private dialogref: MatDialog,
    public ClassificationService:ClassificationService,
    public ClassificationModel: ClassificationModel,
    public doctorservice: DoctorsService,
    public doctorModel: DoctorsModel,
    public CanserModel:CanserModel,
    public CanserService:CanserService,
    public PathologyService:PathologyService,
    public pathologyModel:PathologyModel,
    public MasterdataModel:MasterdataModel,
    public masterdataService:masterdataService,
    public patientmodel:PatientModel,
    public storage: LocalStorageService,
    public mortality : MortalityModel,
    public mortalityservice : MortalityService,
    public companyService : CompanyService,
          private sanitizer: DomSanitizer,
          public patientinsuranceservice : PatientInsuranceService,
          public insurancecopmanyserive : IsuranceCopmanyService,

    ) {}
    @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: any) {
    this.storage.clear('stgDocumentDate');
  }

  ngOnInit(): void {
    this.retriveDoctorLookupTop()
    this.retrievecancerLookup()
    this.retrivePathologyLookupTop()
    this.retriveMasterdata1Lookup()
    this.retriveMasterdata2Lookup()
    this.retriveMasterdata3Lookup()
    this.retriveMasterdata4Lookup()
    this. retriveMasterdataGovLookup()
    this.retriveMasterdataNatLookup()
    this.retriveCompanyLookupTop()
    //this.patientCode = this.storage.retrieve('stgPatientCode')
    this.patientFName = this.storage.retrieve('stpatientname')
    this.recid = this.storage.retrieve('stgid')
    this.dateEntry = formatDate(new Date(), 'yyyy-MM-dd', 'en');
if(this.storage.retrieve('stgDocumentDate') != null)
  {  this.dateEntry = this.storage.retrieve('stgDocumentDate')
  }
   // this.retrievePatient();
    this.getmaxserial();
  }
retriveDoctorLookupTop() {
    this.doctorservice
      .getDoctorsLookupTop(this.compCode)
      .subscribe((data: DoctorsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.doctorsList[i] = data[i];
        }

      });
  }

  retrivePathologyLookupTop() {
    this.PathologyService
      .getPathologyCLookupTop(this.compCode)
      .subscribe((data: PathologyModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.PathologyList[i] = data[i];
        }

      });
  }

  retriveCompanyLookupTop() {
    this.companyService.getLocationLookupTop(this.compCode).subscribe((data: CompanyModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.companyList[i] = data[i];
        }

      });
  }
  retriveMasterdata1Lookup() {
    this.masterdataService
      .getmasterCLookupTop('Nat')
      .subscribe((data: MasterdataModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.MasterListNa[i] = data[i];
        }

      });
  }
  retriveMasterdataGovLookup() {
    this.masterdataService
      .getmasterLookupTopGovernments()
      .subscribe((data: GovernmentsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.MasterListGov[i] = data[i];
        }

      });
  }

  retriveMasterdataNatLookup() {
    this.masterdataService.getmasterCLookupTopNat()
      .subscribe((data: MasterdataModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.MasterListNat[i] = data[i];

        }

      });
  }

  retriveMasterdata2Lookup() {
    this.masterdataService
      .getmasterCLookupTop('sta')
      .subscribe((data: MasterdataModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.MasterList1[i] = data[i];
        }

      });
  }

  retriveMasterdata3Lookup() {
    this.masterdataService
      .getmasterCLookupTop('Occ')
      .subscribe((data: MasterdataModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.MasterList2[i] = data[i];
        }

      });
  }

  retriveMasterdata4Lookup() {
    this.masterdataService
      .getmasterCLookupTop('Gov')
      .subscribe((data: MasterdataModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.MasterList3[i] = data[i];
        }

      });
  }
  calculateAge(){

    //var timeDiff = Math.abs(Date.now() - this.birthDate_V);
     this.birthDate_V =formatDate(this.birthDate, 'yyyy', 'en');
          this.day1 = this.Today;
            var timeDiff = Math.abs(Date.now() - this.birthDate_V);
            this.ageYear1 =this.day1 -this.birthDate_V  ;
            this.ageYear = this.ageYear1.toString();
          }
  retrievecancerLookup()
  {
this.CanserService.getCancerLookupTop().subscribe((data:CanserModel[])=>{
  for(let i=0 ; i <data.length; i++)
  {this.cancerlist[i]=data[i];}})
  }
  retrieveNextSerial() {

    const WK_year = formatDate(new Date(), 'yyyy', 'en');
    this.dataBankService
      .getNextSerial(WK_year, this.compCode)
      .subscribe((data: DatabankModel) => {
        this.patientCode = data.patientCode;
        this.retrievePatient();
      });
      //this.ClearPatientData();
    }
  retrievePatient() {
    //this.patientFName =  this.storage.retrieve('stpatientname');

    this.dataBankService.getPatient(this.patientCode, this.compCode).subscribe((data: DatabankModel) => {
      // this.storage.store('stgPatientCode', this.patientCode);
      //this.patientCode = data.patientCode;

      this.patientFName =  data.patientFName;/// this.storage.retrieve('stpatientname');//data.patientFName;
      this.ageYear = data.ageYear;
      this.birthDate =formatDate(data.birthDate,'yyyy-MM-dd','en') ;
      this.diagnosis = data.diagnosis;
      this.gender = data.gender;
      this.marital = data.marital;
      this.telMobile = data.telMobile;
      this.cancerID = data.cancerID;
      this.addressHome = data.addressHome;
      this.docCode= data.docCode;
      this.email = data.email;
      this.telHome = data.telHome;
      this.pathology = data.pathology;
      this.marital=data.marital;
      this.status = data.status;
      this.compCode = data.compCode;
      this.userID = LocalStorage.name;
      this.email = data.email;
      this.education = data.education;
      this.occupation = data.occupation;
      this.nationality = data.nationality;
      this.gov = data.gov;
      this.status = data.status;
      this.telBusin = data.telBusin;
      this.storage.store('stgid',0);
      //
      // this.patientCode = this.storage.retrieve('stgPatientCode')
      // this.patientName = this.storage.retrieve('stpatientname')

      this.RetrivePatientInsurance();

      if (this.storage.retrieve('stgDocumentDate')==null && formatDate(data.dateEntry,'yyyy-MM-dd','en')== '1970-01-01')
      {this.dateEntry = formatDate(new Date(),'yyyy-MM-dd','en');
         console.log('Shenouda' + data.dateEntry);

        this.getmaxserial();
      }
      else {
        if(data.dateEntry != null)
        {
          this.patientCode = data.patientCode;
          this.dateEntry = formatDate(data.dateEntry,'yyyy-MM-dd','en');
        }
        else{
      this.dateEntry = this.storage.retrieve('stgDocumentDate')
      this.patientCode = this.storage.retrieve('stgPatientCode')
      this.patientName = this.storage.retrieve('stpatientname')
      this.recid = this.storage.retrieve('stgid')
        }
    }


      this.retriveMortality();

      });
    }

    ClearPatientData() {
     // this.storage.store('stgPatientCode', '');
      this.patientCode = '';
      this.patientName = '';
      this.patientFName = '';
      this.patientLName = '';
      this.birthDate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.diagnosis = '';
      this.pathology = '';
      this.marital = '';
      this.gov = 'القاهرة';
      this.nationality ='Egyptian';
      this.occupation = '';
      this.email = '';
      this.telMobile = '';
      this.telHome = '';
      this.telBusin = '';
      this.addressHome = '';
      this.cancerID = '';
      this.docCode = '';
      this.education = '';
      this.status = '';
      this.ageYear ='0';
      this.gender = '';
      this.storage.store('stgid',0);
      this.wk_Acc_Not = false;
      this.wk_Acc_Not1 = true;
      this.medcompany = 0;
      //this.telBusin = '';
      this.dateEntry = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.storage.store('stpatientname','')
      //this.recid = this.storage.retrieve('stgid')
      this.getmaxserial();
    }

    getmaxserial(){
      const wk_year  = formatDate(new Date(), 'yyyy', 'en');
      this.dataBankService.getNextSerial(wk_year, this.compCode)
      .subscribe((data: DatabankModel) => {
        this.patientCode = data.patientCode; });

    }

    submiPatientData() {
      this.pattime  =formatDate(new Date(), 'HH:mm', 'en');
      const str1 = formatDate(new Date(), 'yyyy-MM-dd', 'en') + 'T' + this.pattime+':00.000Z';

      if(this.patientCode == '' || this.patientCode == null){return;}
        this.dataBankModel.patientCode = this.patientCode;


        this.dataBankModel.patientFullName = this.patientName;

        this.dataBankModel.patientFName = this.patientName;
        this.dataBankModel.status = this.status;

        this.dataBankModel.gender = this.gender;
        this.dataBankModel.gov = this.gov;
        this.dataBankModel.marital = this.marital;
        this.dataBankModel.nationality = this.nationality;
        this.dataBankModel.occupation = this.occupation;
        this.dataBankModel.patientFName = this.patientFName;
        this.dataBankModel.email = this.email;
        this.dataBankModel.education = this.education;
        this.dataBankModel.docCode = this.docCode;
        this.dataBankModel.diagnosis = this.diagnosis;
        this.dataBankModel.dateEntry = this.dateEntry;
        this.dataBankModel.cancerID = this.cancerID;
        this.dataBankModel.birthDate = this.birthDate;
        this.dataBankModel.addressHome = this.addressHome;
        this.dataBankModel.telBusin = this.telBusin;
        this.dataBankModel.telMobile = this.telMobile;
        this.dataBankModel.telHome = this.telHome;
        this.dataBankModel.userID =  this.storage.retrieve('stguserid');
        this.dataBankModel.compCode =  this.storage.retrieve('stgcompCode');
        this.dataBankModel.modifiedDate = str1;
        this.dataBankModel.pathology = this.pathology;
        this.recid = this.storage.retrieve('stgid')
        this.dataBankModel.resid = this.recid;


        this.dataBankService.AddPatient(this.dataBankModel).subscribe(data => {
        this.submitMortality();
        this.messagesave();

      },
        error => { alert(error); }
      );

    }

    submitMortality(){
     if (this.mortalidate == ''){this.mortalidate= formatDate(new Date(), 'yyyy-MM-dd', 'en');}

      this.mortality.mortalitypatientcode =  this.patientCode;
      if (this.status == '29') this.mortality.mortalitydeath = '1';
      if (this.status != '29') this.mortality.mortalitydeath = '0';
      this.mortality.mortalidate = formatDate(this.mortalidate, 'yyyy-MM-dd', 'en');
      this.mortality.mortalityreason = this.mortalityreason;
      this.mortality.mortalitynotes = this.mortalitynotes;

      this.mortality.userid = this.userID;
      this.mortality.compcode =  this.storage.retrieve('stgcompCode');
      this.mortality.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.mortalityservice.AddMortality(this.mortality).subscribe(data => {


      },
        error => { alert(error); }
      );
    }

    retriveMortality(){
      this.mortalityservice.GetMortality(this.patientCode, this.compCode)
      .subscribe((data: MortalityModel) => {
        this.mortalitydeath =data.mortalitydeath;
        this.mortalidate = data.mortalidate;
        this.mortalityreason = data.mortalityreason;
        this.mortalitynotes = data.mortalitynotes;
        if(this.mortalitydeath == '1'){this.status = '29' }
        this.hiedMort();
      });
    }
    EditMortality(){

      if(this.patientCode == '' || this.patientCode == null){
        return;
      }
      const dialogRef = this.dialogref.open(MortalityComponent,
        {
          data: {
            dataKey: this.mortality,
            mortalitypatientcode : this.patientCode,
            mortalitydeath : '1',
            mortalidate : this.mortalidate,
            mortalitynotes : this.mortalitynotes,
            mortalityreason : this.mortalityreason,

          },
          width: '50vw',
        });
      dialogRef.afterClosed().subscribe(result => {
       this.retriveMortality();
      });

        const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
    }
    hiedMort(){
         if (this.status == '29'){this.wk_Hied_Mortal = false};
         if (this.status != '29'){this.wk_Hied_Mortal = true};

    }
   messagesave()
{
  Swal({title:'Saved',type:'success',showConfirmButton:false,timer:1500});
   }

   openDialog(){
    this.storage.store('stgid',0);
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent,
    {
      data: {
        dataKey: this.patientModel
      },
       width: '55vw',
  });
  dialogRef.afterClosed().subscribe(result => {
  });

  const dialogSubmitSubscription =
     dialogRef.componentInstance.submitClicked.subscribe(result => {
      this.patientCode = result.patientCode;
      this.RetrivePatientInsurance();
      this.storage.store('stgPatientCode', this.patientCode);
      this.patientFName = result.patientFName;

      this.ageYear = result.ageYear;
      this.birthDate =formatDate(result.birthDate,'yyyy-MM-dd','en') ;
      this.diagnosis = result.diagnosis;
      this.gender = result.gender;
      this.marital = result.marital;
      this.telMobile = result.telMobile;
      this.cancerID = result.cancerID;
      this.addressHome = result.addressHome;
      this.docCode= result.docCode;
      this.email = result.email;
      this.telHome = result.telHome;
      this.pathology = result.pathology;
      this.marital=result.marital;
      this.status = result.status;
      this.compCode = result.compCode;
      this.userID = LocalStorage.name;
      this.email = result.email;
      this.education = result.education;
      this.occupation = result.occupation;
      this.nationality = result.nationality;
      this.gov = result.gov;
      this.status = result.status;
      this.telBusin = result.telBusin;
      this.dateEntry = formatDate(result.dateEntry,'yyyy-MM-dd','en');
      this.storage.store('stgid',0);
      dialogSubmitSubscription.unsubscribe();
      this.retriveMortality();
    });
  }
  DeletePatient(){
    this.dataBankService.delPatient(this.patientCode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: DatabankModel) => {
      }
    );
    this.ClearPatientData();
  }
  MesgDelete(){
    swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.DeletePatient();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
public picked(event: any) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.sellersPermitFile = file;

      this.handleInputChange(file); //turn into base64

    }
    else {
      alert("No file selected");
    }
  }
  handleInputChange(files: any) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }

    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e: any) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.sellersPermitString = base64result;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;

    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);

    if(this.imageSource =='' || this.imageSource == null)
      {
        this.wk_Acc_Not = false;
        this.wk_Acc_Not1 = true;
      }
      else
      {
        this.wk_Acc_Not = true;
        this.wk_Acc_Not1 = false;
      }
  }
OpenDialogPatientInsurance(){
   if(this.patientCode == '' || this.patientCode == null){
        return;
      }
      const dialogRef = this.dialogref.open(PatientIsuranceComponent,
        {
          data: {
            dataKey: this.mortality,
            patientcode : this.patientCode,

          },
          width: '50vw',
        });
      dialogRef.afterClosed().subscribe(result => {
        this.retrievePatient();
       this.retriveMortality();
      });

        const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(result => {
          dialogSubmitSubscription.unsubscribe();
        });
}

  RetriveCompany(){
        this.wk_Acc_Not = false;
        this.wk_Acc_Not1 = true;
        this.insurancecopmanyserive.getIsuranceCopmany(this.medcompany.toString()).subscribe((data: InsuranceCompanyModel) => {
                this.myimage = data.inslogo;
                this.sellersPermitString =  data.inslogo;
                this.myimage =this.sellersPermitString;
                var kk = this.sellersPermitString;

                this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);
                if(data.inslogo =='' || data.inslogo == null)
                  {
                    this.wk_Acc_Not = false;
                    this.wk_Acc_Not1 = true;
                  }
                  else
                  {
                    this.wk_Acc_Not = true;
                    this.wk_Acc_Not1 = false;
                  }

        }

            );
}
RetrivePatientInsurance(){
     this.patientinsuranceservice.getPatientInsurance(this.patientCode).subscribe((data: PatientInsuranceModel) => {

      this.medcompany=data.medcompany;
      this.RetriveCompany();



        });
}
}

